import { toast } from 'react-toastify';

export const NotificationManager = {
    dismiss: (toastId) => {
        return toast.dismiss(toastId);
    },
    success: (content, options) => {
        return toast.success(content, options);
    },

    info: (content, options) => {
        return toast.info(content, options);
    },

    warning: (content, options) => {
        return toast.warning(content, options);
    },
    error: (content, options) => {
        return toast.error(content, options);
    }

}
